import { render, staticRenderFns } from "./VenueSList.vue?vue&type=template&id=040836b2&scoped=true"
import script from "./VenueSList.vue?vue&type=script&lang=js"
export * from "./VenueSList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040836b2",
  null
  
)

export default component.exports